import { useState } from "react";
import "./style.css"

function index({ tabs, onClick }) {
    return (
        <div id="custom-tab-filters">

            {
                tabs?.length > 0 && tabs?.map(({ label, active, gradient = "#d37536-#d37536" }, i) => {
                    gradient = gradient?.split("-") || null;
                    return (
                        <div
                            key={"ct-" + i}
                            style={(gradient && active) ? { backgroundColor: `${gradient?.[0]}`, color: "#fff" } : null}
                            className={active ? "selected" : ""}
                            onClick={() => {
                                onClick(label, i)
                            }}
                        >
                            <h6>{label?.toUpperCase()}</h6>
                        </div>
                    )
                })
            }
        </div>
    );
}

export default index;